<template>
  <div>
    <div class="flex flex-row">
      <div class="items-center flex text-center flex-grow relative justify-center mb-8">
        <h2 class="account-card-title">Users</h2>
        <Button
          size="small"
          class="!absolute right-[0px]"
          variant="outlined"
          @click="companyAdminStore.showAddNewUserDialog = true"
          data-test="add-user-button"
        >
          <AddCircle
            class="w-[16px] h-[16px]"
            :fill="donorStore.mainColor"
          />
          Add New User
        </Button>
      </div>
    </div>
    <div
      class="flex flex-row flex-wrap gap-8 md:justify-between justify-center pb-8"
      v-if="!companyAdminStore.companyUsersLoading"
    >
      <div
        v-for="(user, index) in companyAdminStore.companyUsers"
        :key="`user_${index}`"
        class="md:max-w-[449px] max-w-[330px] w-full"
        :data-test="`user-card-${user.companyGivingUsers_profiles_id}`"
      >
        <CompanyUserCard :user="user" />
      </div>
    </div>
    <div
      v-else
      class="flex flex-row flex-wrap gap-4 justify-around"
    >
      <Skeleton
        width="45%"
        height="200px"
        class="mb-2"
        data-test="skeleton-loader"
      />
      <Skeleton
        width="45%"
        height="200px"
        class="mb-2"
        data-test="skeleton-loader"
      />
    </div>
    <CompanyAddUserModal />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import { useDonorStore } from '@/stores/DonorStore.js';
import CompanyUserCard from '@/components/companyGiving/CompanyUserCard.vue';
import AddCircle from '@/assets/AddCircle.vue';
import CompanyAddUserModal from '@/components/companyGiving/CompanyAddUserModal.vue';

const companyAdminStore = useCompanyAdminStore();

const donorStore = useDonorStore();

companyAdminStore.loadCompanyUsers();
</script>
